export interface HomeProductType {
  id: string;
  // eslint-disable-next-line camelcase
  product_id?: string;
  description?: string;
  image?: string;
  status: string;
  sortOrder?: number;
  country?: string;
  options?: any;
  price?: number;
  priceDiscount?: number;
  productName: string;
  brandLogo?: string;
  link?: string;
  tag?: string;
}

export interface FormHomeProductType {
  image?: string;
  country?: string;
  options?: any;
  productName: string;
  brandLogo?: string;
  link?: string;
  tag?: string;
}

export interface SortHomeProductPayload {
  sortOrderList: {
    id: string;
    sortOrder: number;
  }[];
}

export enum HomeProductStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
